import { Outlet } from 'react-router-dom';

import { ItineraryStepper } from '@/components/ItineraryStepper';

export function ItineraryStepElements() {
  return (
    <>
      <Outlet />
      <ItineraryStepper />
    </>
  );
}
